module.exports = __webpack_public_path__ + "fonts/GillSansStd.woff";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/fonts/GillSansStd.woff
// module id = 89
// module chunks = 0